import { render, staticRenderFns } from "./Columns.vue?vue&type=template&id=56f44125&scoped=true&"
import script from "./Columns.vue?vue&type=script&lang=ts&"
export * from "./Columns.vue?vue&type=script&lang=ts&"
import style0 from "./Columns.vue?vue&type=style&index=0&id=56f44125&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f44125",
  null
  
)

export default component.exports